// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"220ab518","453":"ec7f5fc0","455":"d6c070ac","977":"74d9777e"}[chunkId] + ".chunk.js";
};